import { STATE_KEY } from './constants';

export const isBannerVisible = (state) => state[STATE_KEY].isVisible;
export const getStatus = (state) => state[STATE_KEY].status;
export const getMessage = (state) => state[STATE_KEY].message;
export const getMessageValues = (state) => state[STATE_KEY].messageValues;
export const getBannerKey = (state) => state[STATE_KEY].key;
